import React from 'react';
import {useTitleTransitions} from '@dazn/lp-web/src/hooks/useTransitions';
import {IFaq} from '@dazn/lp-web/src/types/faqs.types';
import styles from '@dazn/lp-web/src/components/Faqs/faqs.module.css';
import {animated} from '@react-spring/web';
import Markdown from 'markdown-to-jsx';
import IconChevron from '@dazn/lp-web/src/components/Rail/Chevron';
import isQueryParamTrue from '../../utils/isQueryparamTrue';

interface IProps {
    data: any;
    key: number;
    disableAnimation: boolean;
}

const Faqs: React.FC<IProps> = ({data, disableAnimation}) => {
    const {title, faqs} = data;

    const [refView, springs] = useTitleTransitions();

    const animations = disableAnimation
        ? {}
        : {
              style: springs,
              ref: refView
          };

    return (
        <div {...animations} className={styles.faqsContainer}>
            <animated.div {...animations}>
                <Markdown className={styles.faqsTitle}>{title}</Markdown>
            </animated.div>
            {faqs?.map((faq: IFaq, index: number) => {
                return isQueryParamTrue('seo') ? (
                    <a
                        key={'faq-' + index + 1}
                        className={styles.faqContainer}
                        target="_blank"
                        href={faq?.url}
                    >
                        <h2 className={styles.faqTitle}>{faq?.title}</h2>
                        <IconChevron />
                    </a>
                ) : (
                    <animated.div
                        {...animations}
                        key={'faq-' + index + 1}
                        className={styles.faqContainer}
                        onClick={faq?.action}
                    >
                        <h2 className={styles.faqTitle}>{faq?.title}</h2>
                        <IconChevron />
                    </animated.div>
                );
            })}
        </div>
    );
};

export default Faqs;
